import React from 'react';
import { SheetCloseButtonProps } from '@kite-js/experimental/lib/Sheet/types';

export const NoOp = () => {};

// TODO: Remove when integrating ACT_3882, ACT-3882
export const CursorPointer: React.CSSProperties = { cursor: 'pointer' };
export const SheetCloseButtonInside: SheetCloseButtonProps = { position: 'inside' };
